<div class="game-end-dialog" [class.light-theme]="data.isDarkTheme === false">
  <h2 mat-dialog-title>
    ¡Juego {{ data.gameNumber }} Finalizado!
  </h2>

  <mat-dialog-content>
    <div class="winner-section">
      <p class="winner-label">Ganador:</p>
      <p class="winner-name">{{ winnerName }}</p>
    </div>

    <div class="score-section">
      <div class="score-display">
        <span class="player-score" [class.winner]="data.winner === 1">
          {{ data.player1Name }} : {{ data.player1Score }}
        </span>
        <span class="score-separator">-</span>
        <span class="player-score" [class.winner]="data.winner === 2">
          {{ data.player2Score }} : {{ data.player2Name }}
        </span>
      </div>
    </div>

    <p class="confirmation-text">¿Confirmar el resultado del juego?</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-raised-button
            color="primary"
            class="confirm-btn"
            (click)="confirmGameEnd()">
      <mat-icon>check_circle</mat-icon>
      Confirmar
    </button>

    <button mat-stroked-button
            class="undo-btn"
            (click)="undoLastPoint()">
      <mat-icon>undo</mat-icon>
      Deshacer último punto
    </button>
  </mat-dialog-actions>
</div>
